import { Component, Input } from '@angular/core';
import { TableInformationRewardsComponent } from '../table-information-rewards/table-information-rewards.component';
import { TableRewardsComponent } from '../table-rewards/table-rewards.component';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-information-fabricator-rewards',
  standalone: true,
  imports: [TableInformationRewardsComponent, TableRewardsComponent, TranslateModule],
  templateUrl: './information-fabricator-rewards.component.html',
  styleUrls: ['./information-fabricator-rewards.component.scss'],
})
export class InformationFabricatorRewardsComponent {
  @Input() eliteStatus!: string;
  @Input() countryWarehouse!: string;

}